"use strict";

(function (globalWebAccess) {

  var FLOAT_DIALOG_TEMPLATE = '/layouts/FloatDialog.compile.html';

  /**
  * Всплывающее диалоговое окно
  *
  * @class WebAccess.components.dialogs.FloatDialog
  * @extends BaseObject
  * @property {String} id ИД диалогового окна
  * @property {Object} settings Настройки диалогового окна
  * @since 5.4.0.1000
  */

  var FloatDialog = BaseObject.extend({

    // Конструктор.
    init: function (id, settings) {
      var me = this;

      me.id = id;
      me.settings = settings;
      if ($.isPlainObject(settings)) {
        $.extend(this, settings);
      }
      me._inited = $.Deferred();

      me._createHtml(); //асинхронная
    },

    _createHtml: function () {
      var me = this;

      var floatDialogTemplate = WA.templates.render(FLOAT_DIALOG_TEMPLATE, $.extend({
        id: me.id,
        title: '',
        showMinimizeButton: true,
        minimized: false,
        showCloseButton: true,
        contentAsHtml: '',
        isLoading: true,
        hidden: false,
        loadingText: L('LOADING')
      }, me.settings));

      // Когда отрендерятся все шаблоны, создаем из них DOM элементы.
      $.when(floatDialogTemplate).done(function (html) {
        me._jDialog = $(html);

        me._jTitle = me._jDialog.find('.float-dialog__header-title');
        me._jMinimizingIcon = me._jDialog.find('.float-dialog__header-icon_toggle-size');
        me._jCloseIcon = me._jDialog.find('.float-dialog__header-icon_close');
        me._jContentArea = me._jDialog.find('.float-dialog__content-area');
        me._jContent = me._jContentArea.find('.float-dialog__content');
        me._jLoading = me._jDialog.find('.float-dialog__loading');
        me._jLoadingText = me._jLoading.find('.float-dialog__loading-text');

        me._bindEvents();

        if ($('#' + me.id).length === 0) {
          me._jDialog.addClass('float-dialog_hidden');
          me._jDialog.appendTo('body');
        }
        // Инициализация закончилась.
        me._inited.resolve();
      });
    },

    // Навешивает события на элементы диалога.
    _bindEvents: function () {
      var me = this;

      me._jMinimizingIcon.on('click', function () {
        me.setMinimized(!me.isMinimized(), true);
      });
      me._jCloseIcon.on('click', function () {
        if (me.fire(me['class'].EVENT.BEFORE_CLOSE, me) === false) return false;
        me.hide();
        me.fire(me['class'].EVENT.AFTER_CLOSE, me);
      });
    },

    /**
    * Добавляет диалоговое окно на страницу и отображает его.
    *
    * @method WebAccess.components.dialogs.FloatDialog#show
    */
    show: function () {
      var me = this;
      $.when(me._inited).done(function () {
        me._jDialog.removeClass('float-dialog_hidden');
      });
    },

    /**
    * Скрывает диалоговое окно.
    *
    * @method WebAccess.components.dialogs.FloatDialog#hide
    */
    hide: function () {
      var me = this;
      $.when(me._inited).done(function () {
        // Минимизировать для анимации сворачивания.
        me.setMinimized(true);
        me._jDialog.addClass('float-dialog_hidden');
      });
    },

    /**
    * Устанавливает новый заголовок диалогового окна.
    *
    * @method WebAccess.components.dialogs.FloatDialog#setTitle
    * @param {string} newTitle Заголовок диалога
    */
    setTitle: function (newTitle) {
      var me = this;
      $.when(me._inited).done(function () {
        me._jTitle.text(newTitle);
      });
    },

    /**
    * Устанавливает новый заголовок диалогового окна в формате HTML.
    *
    * @method WebAccess.components.dialogs.FloatDialog#setTitleAsHtml
    * @param {string} newTitleHtml Заголовок диалога в формате HTML
    */
    setTitleAsHtml: function (newTitleHtml) {
      var me = this;
      $.when(me._inited).done(function () {
        me._jTitle.html(newTitleHtml);
      });
    },

    /**
    * Устанавливает содержимое диалогового окна в формате HTML.
    *
    * @method WebAccess.components.dialogs.FloatDialog#setContentAsHtml
    * @param {string} contentAsHtml Содержимое диалогового окна в формате HTML
    * @param {function} callback Функция, которая будет вызвана при установке значения содержимого
    */
    setContentAsHtml: function (contentAsHtml, callback) {
      var me = this;
      $.when(me._inited).done(function () {
        me._jLoading.hide();
        me._jContent.html(contentAsHtml);
        me._jContent.show();
        if (callback) callback();
      });
    },

    /**
    * Устанавливает содержимое диалогового окна.
    *
    * @method WebAccess.components.dialogs.FloatDialog#setContent
    * @param {string} content Содержимое диалогового окна
    * @param {function} callback Функция, которая будет вызвана при установке значения содержимого
    */
    setContent: function (content, callback) {
      this.setContentAsHtml('<div class="float-dialog__content-as-text">' + content + '</div>', callback);
    },

    /**
    * Показывает сообщение о загрузке.
    *
    * @method WebAccess.components.dialogs.FloatDialog#showLoader
    * @param {string} text Текст сообщения о загрузке
    */
    showLoader: function (text) {
      var me = this;
      $.when(me._inited).done(function () {
        if (text) {
          me._jLoadingText.text(text);
        }
        me._jContent.hide();
        me._jLoading.show();
      });
    },

    /**
    * Проверяет, минимизировано ли диалоговое окно.
    *
    * @method WebAccess.components.dialogs.FloatDialog#isMinimized
    * @return {boolean} True – диалоговое окно минимизировано, иначе False.
    */
    isMinimized: function () {
      var me = this;
      return me._jDialog.hasClass('float-dialog_minimized');
    },

    /**
    * Проверяет, развернул ли пользователь диалоговое окно.
    *
    * @method WebAccess.components.dialogs.FloatDialog#isUserExpanded
    * @return {boolean} True – диалоговое окно развернуто, иначе False.
    */
    isUserExpanded: function () {
      var me = this;
      return WA.cache.getItem('floatdialog.' + me.id + '.expanded') === '1';
    },

    /**
    * Устанавливает признак минимизации диалогового окна.
    *
    * @method WebAccess.components.dialogs.FloatDialog#setMinimized
    * @param {boolean} isMinimized Признак минимизации диалогового окна
    * @param {boolean} saveState Признак сохранения состояния диалогового окна
    */
    setMinimized: function (isMinimized, saveState) {
      var me = this;
      $.when(me._inited).done(function () {
        if (isMinimized) {
          // Сворачиваем.
          me._jDialog.addClass('float-dialog_minimized');
          me._jContentArea.addClass('float-dialog__content-area_minimized');
          me._jLoading.hide();
          me._jMinimizingIcon.removeClass('float-dialog__header-icon_toggle-size_maximized');
        } else {
          // Разворачиваем.
          me._jDialog.removeClass('float-dialog_minimized');
          me._jContentArea.removeClass('float-dialog__content-area_minimized');
          me._jMinimizingIcon.addClass('float-dialog__header-icon_toggle-size_maximized');

          me._jContent.niceScroll({
            cursorcolor: "#d8dce3",
            cursorwidth: "6px",
            cursorborder: "0",
            autohidemode: "false",
            cursorborderradius: "0",
            railpadding: { right: 3 },
            horizrailenabled: false,
            railalign: "right"
          });
        }
      });

      if (saveState)
        WA.cache.setItem('floatdialog.' + me.id + '.expanded', isMinimized ? '0' : '1');
    }
  }, {
    EVENT: {

      /**
      * Срабатывает перед закрытием модального окна.
      * Можно предотвратить закрытие диалогового окна, вернув false в обработчике события.
      *
	    * @event WebAccess.components.dialogs.FloatDialog.EVENT.BEFORE_CLOSE
      * @param {WebAccess.components.dialogs.FloatDialog} dialog Экземпляр диалога
      * @since 5.4.0.1004
      */
      BEFORE_CLOSE: 'beforeClose',

      /**
      * Срабатывает после закрытия диалогового окна.
      *
	    * @event WebAccess.components.dialogs.FloatDialog.EVENT.AFTER_CLOSE
      * @param {WebAccess.components.dialogs.FloatDialog} dialog Экземпляр диалога
      * @since 5.4.0.1004
      */
      AFTER_CLOSE: 'close'
    }
  });

  // ---------------------------------------------------------------------------------------------------
  globalWebAccess.components.dialogs.FloatDialog = FloatDialog;

})(window.WebAccess);
